import React from 'react';
import RoundedProfilePicture from '../profile-picture/rounded-profile-picture.comonent';

export interface ContactItem {
  href?: string;
  icon: string;
  label: string;
  newTab?: boolean;
}

interface ProfileHeaderCardProps {
  contactItems: ContactItem[];
  imageUrl?: string;
  name: string;
  nameHeadingClassName?: string;
  rightActions?: React.ReactNode;
  followersCount?: number;
  followingCount?: number;
  famCount?: number;
  isFollowing?: boolean;
  onToggleFollow?: () => void;
  subtitle?: string;
}

export const ProfileHeaderCard: React.FC<ProfileHeaderCardProps> = ({
  contactItems,
  famCount,
  followersCount,
  followingCount,
  isFollowing,
  imageUrl,
  name,
  nameHeadingClassName = 'text-2xl font-semibold text-gray-900',
  onToggleFollow,
  rightActions,
  subtitle,
}) => {
  const stats = [
    {label: 'Followers', value: followersCount},
    {label: 'Following', value: followingCount},
    {label: 'Fam', value: famCount},
  ];
  const inlineStats = stats.filter(stat => stat.value !== undefined).map(stat => `${stat.value} ${stat.label}`);

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
        <RoundedProfilePicture name={name} size={80} url={imageUrl} />
        <div className="flex flex-col gap-2">
          <div className="flex flex-wrap items-center gap-3">
            <h1 className={nameHeadingClassName}>{name}</h1>
            {contactItems.length > 0 && (
              <div className="flex flex-wrap items-center gap-3">
                {contactItems.map((item, index) => {
                  const content = (
                    <div className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-gray-900">
                      <img alt="" className="h-4 w-4" src={item.icon} />
                      <span className="hidden sm:inline">{item.label}</span>
                    </div>
                  );

                  if (item.href) {
                    return (
                      <a
                        key={index}
                        href={item.href}
                        rel={item.newTab ? 'noopener noreferrer' : undefined}
                        target={item.newTab ? '_blank' : undefined}>
                        {content}
                      </a>
                    );
                  }

                  return <div key={index}>{content}</div>;
                })}
              </div>
            )}
          </div>
          {subtitle && <p className="text-base text-gray-600">{subtitle}</p>}
          {inlineStats.length > 0 && <p className="text-sm font-medium text-gray-700">{inlineStats.join(' · ')}</p>}
          {contactItems.length > 0 && (
            <div className="flex flex-wrap gap-4 mt-2 sm:hidden">
              {contactItems.map((item, index) => {
                const content = (
                  <div className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900">
                    <img alt="" className="h-4 w-4" src={item.icon} />
                    <span>{item.label}</span>
                  </div>
                );

                if (item.href) {
                  return (
                    <a
                      key={index}
                      href={item.href}
                      rel={item.newTab ? 'noopener noreferrer' : undefined}
                      target={item.newTab ? '_blank' : undefined}>
                      {content}
                    </a>
                  );
                }

                return <div key={index}>{content}</div>;
              })}
            </div>
          )}
        </div>
      </div>
      {(onToggleFollow || rightActions) && (
        <div className="flex flex-col items-end gap-3">
          {onToggleFollow && (
            <button
              className={`rounded-full px-4 py-2 text-sm font-semibold ${
                isFollowing ? 'bg-gray-200 text-gray-800' : 'bg-blue-600 text-white'
              }`}
              onClick={() => {
                window.location.href = 'https://app.recco.ai/cE2crMtqoQb';
                onToggleFollow?.();
              }}>
              {isFollowing ? 'Following' : 'Follow'}
            </button>
          )}
          {rightActions && <div className="flex items-center">{rightActions}</div>}
        </div>
      )}
    </div>
  );
};
